export const capitalizeLetter = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  export const convertToUpperCase = (str) => {
    return str.toUpperCase();
  };